export const transformReportInfoResponse = (response: any) => { 
    const cohortsMap: any = {};
    Object.keys(response).forEach(key => {
        if (key === "courses" || key === "feedback") return; // Ignoring these keys
        response[key].forEach((entry: any) => {
            const { cohortId } = entry;

            if (!cohortsMap[cohortId]) {
                cohortsMap[cohortId] = { cohortId };
            }

            cohortsMap[cohortId][key] = entry;
        });
    });
    // Convert object to array
    const transformedResponse = Object.values(cohortsMap);
   return transformedResponse
}